var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-card',{staticClass:"bioCard",attrs:{"width":"80%"}},[_c('p',[_vm._v(_vm._s(this.vuexState.celebID.birthName))]),_c('p',[_vm._v(_vm._s(this.vuexState.celebID.birthDate))])]),_c('AssetFeed')],1)}
var staticRenderFns = []

export { render, staticRenderFns }